import register from '../../../../global/js/registry';
export default register(
	'm-formstep-warranty-wolf-products',
	() => import(/* webpackMode: "lazy" */ './m-formstep-warranty-wolf-products.controller'),
);
